import { render, staticRenderFns } from "./CampanhaStatsRow.vue?vue&type=template&id=708cc933&scoped=true"
import script from "./CampanhaStatsRow.vue?vue&type=script&lang=js"
export * from "./CampanhaStatsRow.vue?vue&type=script&lang=js"
import style0 from "./CampanhaStatsRow.vue?vue&type=style&index=0&id=708cc933&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708cc933",
  null
  
)

export default component.exports